/**
 * <ActivationStudentHeader> — de quel élève on parle (molecule).
 *
 * La première chose que lit un parent arrivé par un mail : il n'a aucun fil d'Ariane, et ces deux
 * repères — « Mon abonnement » et le prénom — sont tout ce qui lui dit qu'il est bien chez lui et
 * pas sur une page marketing (`ActivationLandingScreen.js:329-361`).
 *
 * Le legacy peint la pastille en violet, la signature du mode parent de l'époque. Ici elle prend
 * `role`, le jeton qui nomme l'univers courant : côté parent c'est le marine du livre V13.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Avatar } from "../../atoms/Avatar"
import { Row } from "../../atoms/containers/Row"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { Stack } from "../../atoms/containers/Stack"
import { Title } from "../../atoms/typography/Title"

/** La pastille du legacy — 44 px, le cran du livre juste sous l'avatar signé. */
/** La pastille de l'élève — exportée pour la place que son squelette lui garde. */
export const AVATAR_SIZE = 44

export type ActivationStudentHeaderProps = {
    /** Prénom de l'élève — le view-model pose « votre enfant » quand le back n'en donne pas. */
    firstName: string
    /** Légende au-dessus du prénom — « Mon abonnement », le nom de la surface dans l'espace. */
    legend?: string
    testID?: string
}

export function ActivationStudentHeader(props: ActivationStudentHeaderProps) {
    const { firstName, legend = "Mon abonnement", testID } = props

    return (
        <Row gap="3" testID={testID}>
            <Avatar name={firstName} size={AVATAR_SIZE} backgroundColor="role" textColor="text-on-primary" />
            <Stack gap="0" style={styles.body}>
                <SectionLabel color="role">{legend}</SectionLabel>
                <Title>{firstName}</Title>
            </Stack>
        </Row>
    )
}

const styles = StyleSheet.create(() => ({
    /** Le prénom se replie ; la pastille garde sa taille. */
    body: { flexShrink: 1, flexGrow: 1 },
}))
